import { Button } from 'foundations-components/transitional/components/Button';
import { Alert } from 'foundations-components/transitional/components/Alert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UpdateFilterWithExternalOptionsNotification = ({
  onUpdateClick,
  canFilterBeConverted
}) => {
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "250",
    children: /*#__PURE__*/_jsxs(Alert, {
      "data-test-id": "update-filter-with-external-options-notification",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.externalOptionsFilterUpdate.title"
      }),
      type: "tip",
      paddingInline: "200",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "newCustomerDataFilters.externalOptionsFilterUpdate.text"
      }), !canFilterBeConverted && /*#__PURE__*/_jsx(Alert, {
        "data-test-id": "update-filter-with-external-options-warning",
        type: "warning",
        marginBlockStart: "200",
        paddingInline: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.externalOptionsFilterUpdate.warning"
        })
      }), /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(Button, {
          "data-test-id": "update-filter-with-external-options-button",
          use: "transparent",
          onClick: onUpdateClick,
          responsive: false,
          disabled: !canFilterBeConverted,
          paddingInlineStart: "0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "newCustomerDataFilters.externalOptionsFilterUpdate.action"
          })
        })
      })]
    })
  });
};
export default UpdateFilterWithExternalOptionsNotification;